module.exports = __webpack_public_path__ + "img/menuimg6.8ded77c5.png";